// Toggle Accordion

const AccordionTitle = document.querySelectorAll('.c-AccordionItem_Title');

AccordionTitle.forEach((title) => {
    title.addEventListener('click', (e) => {
    	title.classList.toggle('open');
    })
});

const EligToggle = document.querySelector('.c-SavingsCard_EligibilityToggle');

if (EligToggle) {
    EligToggle.addEventListener('click', () => {
        EligToggle.classList.toggle('is-active');
    })
}